module.exports = __webpack_public_path__ + "media/בית.b0268ce0.mp3";